module.exports = __webpack_public_path__ + "static/media/210.5b2d89a7.png";